<div class="container">
  <fa-icon [icon]="faBack" class="back-icon" [ngbTooltip]="'Back'" (click)="back()" *ngIf="!isAdmin"> </fa-icon>
  <!-- <ngb-carousel #carousel [interval]="3000" [showNavigationIndicators]="false"
      [showNavigationArrows]="headerImage && headerImage.length > 0">
      <ng-template *ngFor="let image of headerImage" ngbSlide>
          <div class="image" [ngClass]="{'carousel-image-sub': isAdmin !== true}">
              <img class="carousel-image" src="{{image?.objectUrl}}" alt="...">
          </div>
      </ng-template>
  </ngb-carousel> -->
  <div class="row">
    <div class="container">
      <div class="col-md-12 pro-main">


        <div class="gallery-top card shadow-lg rounded-3" [ngClass]="{ 'gallery-top1': isAdmin === true }">
          <div class="d-flex justify-content-evenly Main_cont">
            <div class="image-gallery d-flex  col-10 col-md-7 p-2" *ngIf="!isMobile">
              <div class="main-image img-fluid" *ngIf="selectedImage && selectedImage.length > 0"
                (click)="openModal(selectedImage, imageModal)">
                <img [src]="selectedImage" alt="Selected Image" [ngClass]="{ 'property-details': isAdmin !== true }" />
                <div class="action-buttons" [ngClass]="{ 'action-buttons1': isAdmin === true }">
                  <!-- <fa-icon [icon]="faExpand" class="expand"
                              ></fa-icon> -->
                  <button class="btn save" *ngIf="!isAdmin && checkLoginStatus"
                    (click)="$event.stopPropagation(); toggleFavorite($event)">
                    <fa-icon [icon]="faHeart" class="favorite-icon-save"
                      [ngClass]="{ favorite: projectDetails?.favProperty }" [ngbTooltip]="'Save'"></fa-icon>
                    Save
                  </button>
                </div>
                <div class="image-tag" *ngIf="projectDetails?.isTheProjectReraApproved === true">
                  RERA
                </div>
              </div>
              <div class="thumbnail-list d-flex flex-wrap flex-sm-nowrap overflow-auto "
                *ngIf="images && images.length > 0">
                <div class="thumbnail p-1" *ngFor="let image of images" (click)="selectImage(image)">
                  <img [src]="image?.objectUrl" alt="Thumbnail" />
                </div>
              </div>

            </div>

            <div class="">
              <div class="property-right" [ngClass]="{ 'property-right1': isAdmin === true }">
                <div class="container cont-heading">
                  <div class="col-md-12 col-sm-12">
                    <ng-container *ngIf="isMobile">
                      <div class="main-image" *ngIf="selectedImage && selectedImage.length > 0">
                        <img [src]="selectedImage" alt="Selected Image" />
                      </div>
                      <div class="thumbnail-list" *ngIf="images && images.length > 0">
                        <div class="thumbnail" *ngFor="let image of images" (click)="selectImage(image)">
                          <img [src]="image?.objectUrl" alt="Thumbnail" />
                        </div>
                      </div>
                    </ng-container>

                    <div class="amenities-top mt-2 p-2" *ngIf="amenities && amenities.length > 0">
                      <ng-container>
                        <p *ngFor="
                            let amenity of visibleAmenities;
                            let i = index
                          ">
                          <img [src]="amenity?.icon" class="feature-icon" alt="{{ amenity.name }}" />
                          <span class="amenities-text" ngbTooltip="{{ amenity?.name }}">{{ amenity?.name }}</span>
                          <span class="amenities-divider" *ngIf="i === 0"></span>
                        </p>
                        <button class="more-button" *ngIf="showMoreAmenities?.length >0" (click)="scrollToAmenities()">
                          +
                          {{ showMoreAmenities?.length }}
                          More
                        </button>
                      </ng-container>
                    </div>
                  </div>
                  <!-- Parent component (e.g., project-view.component.html) -->
                  <div class="details-section-container mt-2">
                    <div class="main-details-head row g-2">
                      <div class="col-6 col-md-4" *ngIf="projectDetails?.projectName">
                        <div class="details-item">
                          <p class="details-label text-truncate">Project</p>
                          <h5 class="details-value text-break">{{ projectDetails?.projectName }}</h5>
                        </div>
                      </div>
                      <div class="col-6 col-md-4" *ngIf="projectDetails?.projectBy">
                        <div class="details-item">
                          <p class="details-label text-truncate">Developed By</p>
                          <h5 class="details-value text-break">{{ projectDetails?.projectBy }}</h5>
                        </div>
                      </div>
                      <div class="col-6 col-md-4">
                        <div class="details-item" *ngIf="units?.length > 0">
                          <p class="details-label text-truncate">Price</p>
                          <h5 class="details-value text-break">₹{{ minimumPrice }} - {{ maximumPrice }}</h5>
                        </div>
                        <div class="details-item" *ngIf="units?.length === 0">
                          <p class="details-label text-truncate">Price</p>
                          <h5 class="details-value text-break">
                            ₹{{ minimumPrice }}/{{ projectDetails?.minimumSize?.unitType }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-6 col-md-4">
                        <div class="details-item">
                          <p class="details-label text-truncate">Category</p>
                          <h5 class="details-value text-break">{{ projectDetails?.categoryName }}</h5>
                        </div>
                      </div>
                      <div class="col-6 col-md-4">
                        <div class="details-item" *ngIf="units?.length > 0">
                          <p class="details-label text-truncate">Size</p>
                          <h5 class="details-value text-break">
                            {{ projectDetails?.minimumSize?.value }} - {{ projectDetails?.maximumSize?.value }}
                            {{ projectDetails?.maximumSize?.unitType }}
                          </h5>
                        </div>
                        <div class="details-item" *ngIf="units?.length === 0">
                          <p class="details-label text-truncate">Size</p>
                          <h5 class="details-value text-break">
                            {{ projectDetails?.minimumSize?.value }} {{ projectDetails?.maximumSize?.unitType }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-6 col-md-4"
                        *ngIf="projectDetails?.towers && projectDetails?.towers[0]?.value > 0">
                        <div class="details-item">
                          <p class="details-label text-truncate">Floors</p>
                          <h5 class="details-value text-break">{{ getMaxFloors(projectDetails) }}</h5>
                        </div>
                      </div>
                      <div class="col-6 col-md-4" *ngIf="projectDetails?.numberOfTowers !== null">
                        <div class="details-item">
                          <p class="details-label ">Towers</p>
                          <h5 class="details-value ">{{ getTowers(projectDetails) }}</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>

          </div>
          <div class="re-action-buttons-section col-md-12 mt-3">
            <div class="row g-2 justify-content-end">

              <!-- Enquire Now Button -->
              <div class="col-12 col-sm-auto col-md-2" *ngIf="!isAdmin">
                <div class="re-button-wrapper">
                  <app-common-button buttonClass="re-action-btn fw-bold" buttonLabel="Enquire Now"
                    (clickEvent)="openEnquiry()">
                  </app-common-button>
                </div>
              </div>

              <!-- Download Brochure Button -->
              <div class="col-12 col-sm-auto col-md-2 " *ngIf="projectDetails?.brochure?.length">
                <div class="re-button-wrapper" [class.re-admin-style-1]="isAdmin">
                  <app-common-button buttonClass="download-button fw-bold" buttonLabel="Download Brochure"
                    [loadingIcon]="loader" [ngbTooltip]="'Download Brochure'"
                    (clickEvent)="downloadAllBrochures('brochure', 'brochure')">
                  </app-common-button>
                </div>
              </div>

              <!-- View all Documents Button/Link -->
              <div class="col-12 col-sm-auto col-md-2" *ngIf="
                  projectDetails?.brochure?.length > 0 ||
                  projectDetails?.buildingPlan?.length > 0 ||
                  projectDetails?.floorPlan?.length > 0
                ">
                <div class="re-button-wrapper" [class.re-admin-style-2]="isAdmin">
                  <p class="re-action-view fw-bold re-action-text-btn" [class.re-admin-scroll-style]="isAdmin"
                    (click)="scrollToDocuments()" tabindex="0" (keydown.enter)="scrollToDocuments()"
                    (keydown.space)="scrollToDocuments()">
                    View all Documents
                  </p>
                </div>
              </div>

            </div>
          </div>
          <!-- <div class="heading">
                    <p class="heading-text">GALLERY</p>
                  </div> -->
        </div>
      </div>

      <div class="  more-details-container " [ngClass]="{ 'more-details-container1': isAdmin === true }">

        <div class="col-12 shadow-lg rounded-3 mt-5 p-3 more-details">
          <h2 class="floor-plan-text mt-3">MORE DETAILS</h2>
          <div class="sale-cards-container d-flex justify-content-evenly align-items-center mb-4"
            *ngIf="units?.length === 0" [ngClass]="{ 'sale-cards-container-user': isAdmin !== true }">
            <div class="sale-card text-center p-3 mx-2 shadow rounded-lg">
              <p class="sale-text fw-bold mb-2">Asset Value</p>
              <p class="sale-text fs-5">&#8377; {{ totalAssetValue }}</p>
            </div>
            <div class="size-card text-center p-3 mx-2 shadow rounded-lg">
              <p class="sale-text fw-bold mb-2">SIZE</p>
              <p class="sale-text fs-5">
                {{ projectDetails?.size?.value }}
                {{ projectDetails?.size?.unitType }}
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="row g-3 d-flex justify-content-center">
                <div class="col-sm-6 col-md-4 col-lg-3" *ngFor="let unit of units">
                  <div class="card h-100">
                    <div class="card-header text-center bg-warning text-white">
                      <h5 class="card-title mb-0">{{ unit?.unitName }}</h5>
                    </div>
                    <div class="card-body">
                      <p class="card-text">
                        {{ unit?.unitSize?.minSize }}
                        {{ unit?.unitSize?.unitType }} -
                        {{ unit?.unitSize?.maxSize }}
                        {{ unit?.unitSize?.unitType }}
                      </p>
                      <p class="card-text">
                        {{ unit?.unitFacing?.join(", ") }}
                      </p>
                      <p class="card-text fw-bold text-success">
                        {{
                        priceFormatterService.formatPrice(
                        unit?.unitPrice?.minPrice
                        )
                        }}
                        -
                        {{
                        priceFormatterService.formatPrice(
                        unit?.unitPrice?.maxPrice
                        )
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container-fluid">
            <div class="row mt-4 shadow-lg rounded-2 p-3 bg-light">
              <div class="text-center text-md-start mb-2 mb-md-0">
                <p class="fw-bold text-uppercase mb-2">Description:</p>
                <div class="col-lg-12 col-md-10">
                  <div style="max-height: 200px; overflow-y: auto;">
                    <p class="text-wrap text-break mb-0">
                      <span [innerHTML]="projectDetails?.description"></span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row">
    <div class="col-md-12">
        <div class="container">
        <div class="more-details">
            <h2>About Project</h2>
          <div class="col-md-12 pull-left">
            <div class="about-project">
                <div class="col-md-2 pull-left">
                    <div class="about-project-image" *ngIf="images && images.length > 0">
                        <img [src]="images[0]?.objectUrl" alt="Thumbnail">
                    </div>
                </div>
                <div class="col-md-3 pull-left">
                    <div class="about-project-text">
                        <h2>{{projectDetails?.projectName}}</h2>
                        <p>by {{projectDetails?.projectBy}}</p>
                    </div>
                </div>
                <div class="col-md-2">
                    <div  class="about-project-text">
                        <p>Price</p>
                        <h2>₹{{minimumPrice}}-{{maximumPrice}}</h2>
                    </div>
                </div>
            </div>
          </div>
          <div class="col-md-12 mt-2 pull-left">
            <div class="about-project">
                <div class="col-md-2 pull-left">
                    <div class="about-project-text">
                        <h2>{{projectDetails?.projectName}}</h2>
                        <p>by {{projectDetails?.projectBy}}</p>
                    </div>
                </div>
                <div class="col-md-3 pull-left">
                    <div class="about-project-text">
                        <h2>{{projectDetails?.projectName}}</h2>
                        <p>by {{projectDetails?.projectBy}}</p>
                    </div>
                </div>
                <div class="col-md-2">
                    <div  class="about-project-text">
                        <p>Price</p>
                        <h2>₹{{minimumPrice}}-{{maximumPrice}}</h2>
                    </div>
                </div>
            </div>
          </div>
        </div>

    </div>
    </div>
</div> -->
        <!-- <div class="description-heading" *ngIf="projectDetails">
      <p class="description-heading-text">{{projectDetails?.projectName}}</p>
      <p class="description-text">
          {{projectDetails?.description}}
      </p>
  </div>
  <div class="amenities-container" *ngIf="projectDetails?.numberOfTowers !== null">
      <div class="amenity">
          <div class="amenity-text">
              {{ getTowers(projectDetails) }}
          </div>
          <div class="amenity-icon">
              <fa-icon [icon]="faTower" class="favorite-icon"></fa-icon>
          </div>
      </div>
      <div class="divider"></div>
      <div class="amenity">
          <div class="amenity-text">
              {{ getMaxFloors(projectDetails) }}
          </div>
          <div class="amenity-icon">
              <fa-icon [icon]="faFloor" class="favorite-icon"></fa-icon>
          </div>
      </div>
  </div> -->
        <div class="floor-plan col-12 shadow-lg rounded-3 mt-5 p-3" *ngIf="floorPlan.length > 0"
          [ngClass]="{ 'floor-plan1': isAdmin === true }">
          <p class="floor-plan-text mt-3">FLOOR PLAN</p>
          <ngb-carousel #carousel [interval]="0" [showNavigationIndicators]="false"
            [showNavigationArrows]="floorPlan && floorPlan.length > 1">
            <ng-template *ngFor="let image of floorPlan" ngbSlide>
              <a *ngIf="!image?.isImage" [href]="image?.objectUrl" target="_blank" class="view-icon1"
                [ngClass]="{ 'view-icon': isAdmin === true }">
                <app-common-button buttonClass="smallbuttoncancel" buttonLabel="View Pdf"></app-common-button>
              </a>
              <div class="floor-image d-flex justify-content-center align-items-center" style="min-height:100%;">
                <ng-container *ngIf="image">
                  <img *ngIf="image?.isImage; else pdfIcon" [src]="image?.objectUrl" alt="Floor Plan"
                    style="max-width:100%; width: 600px; max-height:auto; height: 400px; object-fit:contain; display:block;" />
                  <ng-template #pdfIcon>
                    <img src="../../assets/images/Files.svg" alt="Thumbnail" class="pdf-icon1"
                      [ngClass]="{ 'pdf-icon': isAdmin === true }" style="width:120px; height:auto; display:block;" />
                  </ng-template>
                </ng-container>
              </div>
            </ng-template>
          </ngb-carousel>
          <!-- <div class="floor-plan-text-sub">
          <p>To arrive at Viridā in Kareempur, situated around 74 kilometers from Hyderabad's Financial District in
              the western suburbs, follow the path through Shankarpally, which is roughly 40 kilometers away, and
              continue for approximately 15 kilometers towards Mominpet. This route provides picturesque vistas and
              typically takes about 90 minutes by road. For precise directions, refer to online maps or navigation
              apps.
          </p>
      </div> -->
        </div>
        <div class="background-container col-12 shadow-lg rounded-3 mt-5 p-3" *ngIf="amenities && amenities.length > 0"
          #amenitiesSection [ngClass]="{ 'background-container1': isAdmin === true }">
          <div class="content-overlay">
            <p class="main-title">Unique Attributes & Characteristics</p>
            <!-- <p class="description">Vīridā blends rustic charm with modern comfort. It's carefully designed to create
              a peaceful place where nature meets sophistication. Experience amenities tailored to today’s
              families without compromising their lifestyle.</p> -->
            <div class="features-container">
              <div class="features-list">
                <ng-container *ngIf="amenities && amenities.length > 0">
                  <div class="feature-item" *ngFor="let amenity of amenities">
                    <img [src]="amenity?.icon" class="feature-icon" alt="{{ amenity.name }}" />
                    <span>{{ amenity?.name }}</span>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>


        <div class="col-12 mt-5 mb-2 p-3 shadow-lg rounded-3 ">
           <div class=" align-items-center map-container"
          *ngIf="projectDetails?.formattedAddress">
          <div class="location">
            <p class="floor-plan-text mt-3 " [ngClass]="{ 'location-heading1': isAdmin === true }">
              LOCATION
            </p>
          </div>
         <div class="">
           <div class="col-12 order-lg-1">
            <div [ngClass]="{ 'card-maps': isAdmin !== true }" class="maps card-maps">
              <iframe [src]="mapUrl" class="map-iframe" style="border: 0" allowfullscreen="" loading="lazy"
                referrerpolicy="no-referrer-when-downgrade">
              </iframe>
            </div>
          </div>
          <div class="col-lg-3 order-lg-2">
            <div class="address-card" [ngClass]="{ 'address-card1': isAdmin === true }">
              <h5>Address :</h5>
              <p>{{ projectDetails?.formattedAddress }}</p>
            </div>
            <div class="location-text" [ngClass]="{ 'location-text1': isAdmin === true }">
              <!-- <p>{{projectDetails?.formattedAddress}}</p> -->
            </div>
            <!-- <div class="location-description">
                      <p>Discover Kareempur, nestled near Mominpet in Greater Hyderabad. This unique blend of natural beauty
                          and growth opportunities is just a stone's throw away from Kotpally Reservoir. Imagine serene
                          surroundings, lush landscapes, and abundant wildlife, all accompanied by a refreshing breeze
                      </p>
                  </div> -->
          </div>
         </div>
        </div>
        <ng-container *ngIf="validVicinity?.length > 0">
  <h5 class="floor-plan-text mt-4">Nearby Locations</h5>

  <div class="d-flex flex-wrap gap-2 gap-lg-4 justify-content-start">
    <div *ngFor="let v of validVicinity">
      <div class="bubble text-center px-3 py-2">
        <i class="bi bi-geo-alt-fill me-1 text-danger"></i>
        <span class="fw-semibold">{{ v?.facility }}</span>
        <small class="text-muted ms-1" *ngIf="v?.distance > 0">
          ({{ v?.distance }} km)
        </small>
      </div>
    </div>
  </div>
</ng-container>
        </div>

                  <!-- Videos Section -->
                  <div class="shadow-lg rounded-3 mt-5 p-3"
                    *ngIf="(video && video.length > 0) || (galleryVideos && galleryVideos.length > 0)">
                  
                    <div class="construction construction-videos" [ngClass]="{ construction1: isAdmin === true }">
                      <p class="floor-plan-text mt-4">
                        VIDEOS
                      </p>
                    </div>
                  
                    <div class="construction-sub" [ngClass]="{ 'construction-sub1': isAdmin === true }">
                      <ngb-carousel #carousel [interval]="0" [showNavigationIndicators]="false"  (slide)="onSlideChange($event)"
                        [showNavigationArrows]="((video?.length || 0) + (galleryVideos?.length || 0)) > 1">                  
                        <ng-template *ngFor="let vid of video" ngbSlide>
                          <div class="video-slide">
                            <iframe width="420" height="345" [src]="vid?.urlSafe" style="border: 0; width: 100%" allowfullscreen
                              loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                          </div>
                        </ng-template>
                  
                        <ng-template *ngFor="let vid of galleryVideos" ngbSlide>
                          <div class="video-slide">
                            <video  #videoEl *ngIf="vid?.objectUrl" width="100%" height="345" controls preload="metadata" 
                              style="margin-top: 10px; border-radius: 8px;">
                              <source [src]="vid?.objectUrl" type="video/mp4">
                              Your browser does not support HTML video.
                            </video>
                          </div>
                        </ng-template>                  
                      </ngb-carousel>
                    </div>
                  </div>


        <div class="construction shadow-lg rounded-3 mt-5 p-3 mb-2" *ngIf="
          projectDetails?.brochure?.length ||
          projectDetails?.buildingPlan?.length ||
          projectDetails?.floorPlan?.length
        ">
          <p class="floor-plan-text mt-4" [ngClass]="{ 'documents-p': isAdmin !== true }">
            DOCUMENTS
          </p>
            <div class="container" #documentsSection [ngClass]="{ 'buttons-end': isAdmin !== true }">
          <div class="d-flex flex-wrap flex-md-nowrap gap-2 gap-md-4 justify-content-center justify-content-md-center mb-3"
            [ngClass]="{ document_section: isAdmin === true }">


<div class="col-lg-3 col-md-4 mb-4" *ngIf="projectDetails?.brochure?.length">
  <div class="card h-100 text-center border-0 shadow-sm enhanced-card-dark">
    <div class="card-body p-4 d-flex flex-column">
      <div class="icon-circle mb-4 mx-auto">
  <fa-icon [icon]="mainIcon"></fa-icon>
      </div>
      <h5 class="card-title fw-bold mb-3">Brochure</h5>
      <p class="small flex-grow-1">
        View project details, features, and promotional materials.
      </p>
      <div class="mt-auto">
        <button class="btn fw-semibold w-100" (click)="downloadAllBrochures('brochure')">
           <fa-icon [icon]="faDownload"></fa-icon>
          Download
        </button>
      </div>

    </div>
  </div>
</div>

<div class="col-lg-3 col-md-4 mb-4" *ngIf="projectDetails?.buildingPlan?.length">
  <div class="card h-100 text-center border-0 shadow-sm enhanced-card-dark">
    <div class="card-body p-4 d-flex flex-column">
      <div class="icon-circle mb-4 mx-auto">
         <fa-icon [icon]="faFloor"></fa-icon>
      </div>
      <h5 class="card-title fw-bold mb-3">Building Plan</h5>
      <p class="small flex-grow-1">
        Detailed architectural blueprints for the entire structure.
      </p>
      <div class="mt-auto">
        <button class="btn fw-semibold w-100" (click)="downloadAllBrochures('buildingPlan')">
          <fa-icon [icon]="faDownload"></fa-icon>
          Download
        </button>
      </div>
    </div>
  </div>
</div>

<div class="col-lg-3 col-md-4 mb-4" *ngIf="projectDetails?.floorPlan?.length">
  <div class="card h-100 text-center border-0 shadow-sm enhanced-card-dark">
    <div class="card-body p-4 d-flex flex-column">
      <div class="icon-circle mb-4 mx-auto">
         <fa-icon [icon]="mapIcon"></fa-icon>
      </div>
      <h5 class="card-title fw-bold mb-3">Floor Plan</h5>
      <p class="small flex-grow-1">
        Layout specifications and dimensions for each level of the building.</p>
      <div class="mt-auto">
        <button class="btn fw-semibold w-100" (click)="downloadAllBrochures('floorPlan')">
         <fa-icon [icon]="faDownload"></fa-icon>
          Download
        </button>
      </div>
    </div>
  </div>
</div>
          </div>
        </div>
        </div>
        <!-- <br> -->
        <!-- <div  class="card-container" #documentsSection>
                <div class="card-info" *ngIf="projectDetails?.brochure?.length">
                    <p class="construction-text">Brochure</p>
                    <fa-icon [icon]="faDownload" class="construction-icon" [ngbTooltip]="'Download Brochure'"
                        (click)="downloadAllBrochures('brochure')"></fa-icon>
                </div>
                <div class="card-info" *ngIf="projectDetails?.buildingPlan?.length">
                    <p class="construction-text">Building Plan</p>
                    <fa-icon [icon]="faDownload" class="construction-icon" [ngbTooltip]="'Download Building Plan'"
                        (click)="downloadAllBrochures('buildingPlan','buildingPlan')"></fa-icon>
                </div>
                <div class="card-info" *ngIf="projectDetails?.floorPlan?.length">
                    <p class="construction-text">Floor Plan</p>
                    <fa-icon [icon]="faDownload" class="construction-icon" [ngbTooltip]="'Download Floor Plan'"
                        (click)="downloadAllBrochures('floorPlan','floorPlan')"></fa-icon>
                </div>
            </div> -->


      </div>
    </div>
  </div>

  <app-enquiry-popup [propertyId]="selectedPropertyId" [isEnquiry]="isEnquiry"
    (closeModal)="closeEnquiry()"></app-enquiry-popup>

  <div *ngIf="!checkLoginStatus">
    <app-login-popup [isVisible]="isLoginModalVisible" (closeModal)="closeProjectModal()"></app-login-popup>
  </div>
  <ng-template #imageModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Image Gallery</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="image-container">
        <button class="nav-btn left" (click)="prevImage()" *ngIf="images.length > 1">
          <fa-icon [icon]="faChevronLeft"></fa-icon>
        </button>

        <img [src]="images[currentIndex]?.objectUrl" alt="Full View" class="img-fluid main-image2" />

        <button class="nav-btn right" (click)="nextImage()" *ngIf="images.length > 1">
          <fa-icon [icon]="faChevronRight"></fa-icon>
        </button>
      </div>
    </div>
  </ng-template>
